import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import memberApi from '../lib/memberApi';

const MemberAuthContext = createContext();

export function MemberAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('member_token'));
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(!!localStorage.getItem('member_token'));

  const refreshMember = useCallback(async () => {
    try {
      const res = await memberApi.get('/members/me');
      setMember(res.data);
      return res.data;
    } catch {
      return null;
    }
  }, []);

  useEffect(() => {
    let active = true;
    if (token) {
      memberApi
        .get('/members/me')
        .then((res) => {
          if (active) setMember(res.data);
        })
        .catch(() => {
          if (active) {
            setToken(null);
            localStorage.removeItem('member_token');
          }
        })
        .finally(() => {
          if (active) setLoading(false);
        });
    } else {
      setLoading(false);
    }
    return () => {
      active = false;
    };
  }, [token]);

  const login = async (email, password) => {
    const res = await memberApi.post('/members/auth/login', { email, password });
    const t = res.data.token;
    localStorage.setItem('member_token', t);
    setToken(t);
    setMember({ email: res.data.email, first_name: res.data.first_name, last_name: res.data.last_name });
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('member_token');
    setToken(null);
    setMember(null);
  };

  return (
    <MemberAuthContext.Provider
      value={{ token, member, loading, login, logout, refreshMember, setMember, isAuthenticated: !!token }}
    >
      {children}
    </MemberAuthContext.Provider>
  );
}

export const useMemberAuth = () => useContext(MemberAuthContext);
